
    <footer *ngIf="companyID == 'MPI'">
        <div class="footer">Copyright © Massachusetts Property Insurance Underwriting Association, 2021</div>
    </footer>
    <footer *ngIf="companyID == 'RIJ'">
        <div class="footer">Copyright © Rhode Island Joint Reinsurance Association, 2021</div>
    </footer>
